import { TFooterV2Links } from '../types'

export const TopIndianStocksColumns = [
  {
    title: '1-5',
    listItem: [
      {
        title: 'Tata Motors Share Price – Latest Updates & Chart',
        relative_path: '/stocks/tata-motors-ltd-share-price',
      },
      {
        title: 'Eternal (Zomato) Share Price – Former Zomato Stock',
        relative_path: '/stocks/eternal-ltd-share-price',
      },
      {
        title: 'Tata Power Share Price – Power Sector Leader',
        relative_path: '/stocks/tata-power-company-ltd-share-price',
      },
      {
        title: 'NHPC Share Price – Hydropower PSU Stock',
        relative_path: '/stocks/nhpc-ltd-share-price',
      },
      {
        title: 'Reliance Industries Share Price – RIL Stock Performance',
        relative_path: '/stocks/reliance-industries-ltd-share-price',
      },
    ],
  },
  {
    title: '6-10',
    listItem: [
      {
        title: 'IRCTC Share Price – Indian Railways Catering Stock',
        relative_path:
          '/stocks/indian-railway-catering-and-tourism-corporation-ltd-share-price',
      },
      {
        title: 'IRFC Share Price – Railway Finance PSU',
        relative_path:
          '/stocks/indian-railway-finance-corporation-ltd-share-price',
      },
      {
        title: 'Yes Bank Share Price – Private Bank Stock Today',
        relative_path: '/stocks/yes-bank-ltd-share-price',
      },
      {
        title: 'Tata Steel Share Price – Leading Steel Manufacturer',
        relative_path: '/stocks/tata-steel-ltd-share-price',
      },
      {
        title: 'Reliance Power Share Price – Power Generation Stock',
        relative_path: '/stocks/reliance-power-ltd-share-price',
      },
    ],
  },
  {
    title: '11-15',
    listItem: [
      {
        title: 'Suzlon Energy Share Price – Renewable Energy Stock',
        relative_path: '/stocks/suzlon-energy-ltd-share-price',
      },
      {
        title: 'LIC Share Price – Life Insurance Corporation of India',
        relative_path:
          '/stocks/life-insurance-corporation-of-india-share-price',
      },
      {
        title: 'Adani Green Energy Share Price – Renewable Stock Leader',
        relative_path: '/stocks/adani-green-energy-ltd-share-price',
      },
      {
        title: 'Adani Power Share Price – Thermal Power Stock',
        relative_path: '/stocks/adani-power-ltd-share-price',
      },
      {
        title: 'HDFC Bank Share Price – Top Private Bank in India',
        relative_path: '/stocks/hdfc-bank-ltd-share-price',
      },
    ],
  },
  {
    title: '16-20',
    listItem: [
      {
        title: 'Ashok Leyland Share Price – Commercial Vehicle Stock',
        relative_path: '/stocks/ashok-leyland-ltd-share-price',
      },
      {
        title: 'Vedanta Share Price – Mining & Natural Resources Stock',
        relative_path: '/stocks/vedanta-ltd-share-price',
      },
      {
        title: 'SBI Share Price – State Bank of India Stock Today',
        relative_path: '/stocks/state-bank-of-india-share-price',
      },
      {
        title: 'BPCL Share Price – Bharat Petroleum Stock Performance',
        relative_path: '/stocks/bharat-petroleum-corporation-ltd-share-price',
      },
      {
        title: 'SAIL Share Price – Steel Authority of India Stock',
        relative_path: '/stocks/steel-authority-of-india-ltd-share-price',
      },
    ],
  },
]

export const IndianStocksCategoryColumns = [
  {
    title: 'Market Performance & Trends',
    listItem: [
      {
        title: 'Today’s Share Market Update',
        relative_path: '/market',
      },
      {
        title: 'Top Gainer Stocks Today',
        relative_path: '/stocks/category/top-gainers',
      },
      {
        title: 'Top Loser Stocks Today',
        relative_path: '/stocks/category/top-losers',
      },
      {
        title: 'Stocks at 52-Week High',
        relative_path: '/stocks/category/52-week-high',
      },
      {
        title: 'Stocks at 52-Week Low',
        relative_path: '/stocks/category/52-week-low',
      },
      {
        title: 'Nifty 50 Stocks List',
        relative_path: '/stocks/category/nifty-50-stocks',
      },
    ],
  },
  {
    title: 'Investment Opportunities & Strategies',
    listItem: [
      {
        title: 'Best Penny Stocks to Buy Today',
        relative_path: '/stocks/category/penny-stocks',
      },
      {
        title: 'Top Stocks to Buy Today for Short-Term & Long-Term',
        relative_path: '/stocks/category/buy-stocks',
      },
      {
        title: 'High Dividend Yield Stocks in India',
        relative_path: '/stocks/category/dividend-stocks',
      },
      {
        title: 'Latest Bonus Shares Announced',
        relative_path: '/stocks/category/bonus-shares',
      },
      {
        title: 'Multibagger Stocks for Long-Term Investment',
        relative_path: '/stocks/category/multibagger-stocks',
      },
    ],
  },
  {
    title: 'Top Sectors',
    listItem: [
      {
        title: 'Best Blue Chip Stocks in India',
        relative_path: '/stocks/category/blue-chip-stocks',
      },
      {
        title: 'Top PSU Stocks to Invest In',
        relative_path: '/stocks/category/psu-stocks',
      },
      {
        title: 'Top Defence Sector Stocks in India',
        relative_path: '/stocks/category/defence',
      },
      {
        title: 'Best EV Stocks in India',
        relative_path: '/stocks/category/ev-stocks',
      },
      {
        title: 'Leading Ethanol Stocks in India',
        relative_path: '/stocks/category/ethanol-stocks',
      },
    ],
  },
  {
    title: 'Group & Company Stocks',
    listItem: [
      {
        title: 'Adani Group Shares List',
        relative_path: '/stocks/category/adani-group-shares',
      },
      {
        title: 'Top HDFC Group Stocks',
        relative_path: '/stocks/category/hdfc-group-shares',
      },
      {
        title: 'Tata Group Shares to Watch',
        relative_path: '/stocks/category/tata-group-shares',
      },
      {
        title: 'Bajaj Group Stocks',
        relative_path: '/stocks/category/bajaj-group-shares',
      },
      {
        title: 'Ambani Group (Reliance) Stocks List',
        relative_path: '/stocks/category/ambani-group-shares',
      },
    ],
  },
]

export const TopIndicesColumns = [
  {
    title: 'Broad Market Indices',
    listItem: [
      {
        title: 'NIFTY 50 Index – Live Chart & Performance',
        relative_path: '/indices/nifty-50',
      },
      {
        title: 'NIFTY 500 – Broad Market Index',
        relative_path: '/indices/nifty-500',
      },
      {
        title: 'NIFTY Midcap 100 – Mid Cap Stocks Index',
        relative_path: '/indices/nifty-midcap-100',
      },
      {
        title: 'BSE Sensex – Latest Stock Market Index',
        relative_path: '/indices/sensex',
      },
      {
        title: 'BANKEX Index – Top Banking Stocks',
        relative_path: '/indices/bankex',
      },
      {
        title: 'BSE 500 – Complete Stock Index',
        relative_path: '/indices/bse-500',
      },
    ],
  },
  {
    title: 'Sectoral Indices',
    listItem: [
      {
        title: 'NIFTY Bank – Top Bank Stocks in India',
        relative_path: '/indices/bank-nifty',
      },
      {
        title: 'FIN NIFTY – Financial Services Index',
        relative_path: '/indices/nifty-financial',
      },
      {
        title: 'NIFTY IT – Top IT Sector Stocks Index',
        relative_path: '/indices/nifty-it',
      },
      {
        title: 'NIFTY Pharma – Leading Pharma Stocks',
        relative_path: '/indices/nifty-pharma',
      },
      {
        title: 'NIFTY Auto Index – Best Auto Sector Stocks',
        relative_path: '/indices/nifty-auto',
      },
    ],
  },
  {
    title: 'Thematic Indices',
    listItem: [
      {
        title: 'NIFTY CPSE – Central Public Sector Stocks',
        relative_path: '/indices/nifty-cpse',
      },
      {
        title: 'NIFTY Infrastructure Index – Infra Sector Stocks',
        relative_path: '/indices/nifty-infra',
      },
      {
        title: 'NIFTY MNC Index – Top MNC Companies',
        relative_path: '/indices/nifty-mnc',
      },
      {
        title: 'NIFTY Commodities – Commodity Sector Index',
        relative_path: '/indices/nifty-commodities',
      },
      {
        title: 'NIFTY Energy – Energy Sector Stocks Index',
        relative_path: '/indices/nifty-energy',
      },
    ],
  },
  {
    title: 'Global Indices',
    listItem: [
      {
        title: 'Gift Nifty – Live SGX Nifty Prices',
        relative_path: '/indices/global-indices/gift-nifty',
      },
      {
        title: 'Dow Jones Industrial Average (DJIA) – US Market Index',
        relative_path: '/indices/global-indices/dow-jones-industrial-average',
      },
      {
        title: 'S&P 500 Index – Top US Companies',
        relative_path: '/indices/global-indices/s-p-500',
      },
      {
        title: 'Russell 2000 Index – Small Cap US Stocks',
        relative_path: '/indices/global-indices/russell-2000-index',
      },
      {
        title: 'Dow Jones Market Index – US Stock Trends',
        relative_path: '/indices/global-indices/dow-jones-market',
      },
    ],
  },
]

export const MoreColumns = [
  {
    title: 'IPOs',
    listItem: [
      {
        title: 'Upcoming & Ongoing IPOs in India',
        relative_path: '/ipo',
      },
      {
        title: 'Check IPO Allotment Status Online',
        relative_path: '/ipo/ipo-allotment-status',
      },
    ],
  },
  {
    title: 'ETFs',
    listItem: [
      {
        title: 'Top ETFs in India – Invest in Exchange Traded Funds',
        relative_path: '/stocks/etf',
      },
      {
        title: 'Gold ETFs – Best Gold ETF Funds in India',
        relative_path: '/stocks/category/gold-etfs',
      },
      {
        title: 'CPSE ETF – Price, NAV & Performance',
        relative_path: '/stocks/cpse-etf-share-price',
      },
      {
        title: 'Bharat 22 ETF – Share Price & Holdings',
        relative_path: '/stocks/bharat-22-etf-share-price',
      },
      {
        title: 'Nippon India Silver ETF – Live Price & Details',
        relative_path: '/stocks/nippon-india-silver-etf-share-price',
      },
    ],
  },
  {
    title: 'Gold Rates',
    listItem: [
      {
        title: 'Today’s Gold Rate in India – 22K & 24K Live Prices',
        relative_path: '/gold-rates',
      },
      {
        title: 'Gold Price in Delhi Today – 22K & 24K',
        relative_path: '/gold-rates/delhi',
      },
      {
        title: 'Gold Rate in Mumbai Today – Live Updates',
        relative_path: '/gold-rates/mumbai',
      },
      {
        title: 'Gold Price in Bangalore – 22 Carat & 24 Carat',
        relative_path: '/gold-rates/bangalore',
      },
      {
        title: 'Gold Rate in Pune Today – Latest Price Trends',
        relative_path: '/gold-rates/pune',
      },
    ],
  },
]

export const TopMutualFundsColumns = [
  {
    title: 'Equity Funds',
    listItem: [
      {
        title: 'SBI Energy Opportunities Fund – Direct Growth',
        relative_path:
          '/mutual-funds/sbi-energy-opportunities-fund-direct-growth-1044857',
      },
      {
        title: 'Quant Small Cap Fund – Direct Plan Growth',
        relative_path:
          '/mutual-funds/quant-small-cap-fund-growth-option-direct-plan-611',
      },
      {
        title: 'Parag Parikh Flexi Cap Fund – Direct Growth NAV',
        relative_path:
          '/mutual-funds/parag-parikh-flexi-cap-direct-growth-3229',
      },
      {
        title: 'JM Small Cap Fund – Direct Growth Plan',
        relative_path: '/mutual-funds/jm-small-cap-fund-direct-growth-1045777',
      },
      {
        title: 'Motilal Oswal Multi Cap Fund – Direct Growth',
        relative_path:
          '/mutual-funds/motilal-oswal-multi-cap-fund-direct-growth-1045938',
      },
    ],
  },
  {
    title: 'Debt Funds',
    listItem: [
      {
        title: 'Mahindra Manulife Liquid Fund – Direct Growth NAV',
        relative_path:
          '/mutual-funds/mahindra-manulife-liquid-fund-direct-plan-growth-1200',
      },
      {
        title: 'HDFC Low Duration Fund – Direct Plan Growth',
        relative_path:
          '/mutual-funds/hdfc-low-duration-direct-plan-growth-option-1481',
      },
      {
        title: 'UTI Short Duration Fund – Direct Growth Option',
        relative_path:
          '/mutual-funds/uti-short-duration-fund-direct-plan-growth-option-2316',
      },
      {
        title: 'Aditya Birla Sun Life Corporate Bond – Direct Growth',
        relative_path:
          '/mutual-funds/aditya-birla-sun-life-corporate-bond-fund-direct-plan-growth-4676',
      },
      {
        title: 'Kotak Dynamic Bond Fund – Direct Growth',
        relative_path: '/mutual-funds/kotak-dynamic-bond-direct-growth-5069',
      },
    ],
  },
  {
    title: 'Hybrid Funds',
    listItem: [
      {
        title: 'ICICI Prudential Bharat 22 FOF – Direct Growth',
        relative_path:
          '/mutual-funds/icici-prudential-bharat-22-fof-direct-growth-5380',
      },
      {
        title: 'SBI Equity Hybrid Fund – Direct Growth NAV',
        relative_path:
          '/mutual-funds/sbi-equity-hybrid-fund-direct-growth-4170',
      },
      {
        title: 'ICICI Prudential Multi-Asset Fund – Direct Growth',
        relative_path:
          '/mutual-funds/icici-prudential-multi-asset-fund-direct-plan-growth-4646',
      },
      {
        title: 'ICICI Prudential Equity & Debt Fund – Direct Plan Growth',
        relative_path:
          '/mutual-funds/icici-prudential-equity-debt-fund-direct-plan-growth-4108',
      },
    ],
  },
  {
    title: 'Index Funds',
    listItem: [
      {
        title: 'Motilal Oswal Nifty India Defence Index Fund – Direct Growth',
        relative_path:
          '/mutual-funds/motilal-oswal-nifty-india-defence-index-fund-direct-growth-1046132',
      },
      {
        title: 'Motilal Oswal S&P 500 Index Fund – Direct Growth NAV',
        relative_path:
          '/mutual-funds/motilal-oswal-sp-500-index-fund-direct-growth-1005898',
      },
      {
        title: 'Navi Nifty 50 Index Fund – Direct Growth Plan',
        relative_path:
          '/mutual-funds/navi-nifty-50-index-fund-direct-growth-1039539',
      },
      {
        title: 'UTI Nifty 50 Index Fund – Direct Growth NAV',
        relative_path:
          '/mutual-funds/uti-nifty-50-index-fund-growth-option-direct-5603',
      },
    ],
  },
]

export const TopMutualFundAMCsColumns = [
  {
    title: '1-5',
    listItem: [
      {
        title: 'Quant Mutual Fund',
        relative_path: '/mutual-funds/amc/quant-mutual-fund',
      },
      {
        title: 'Tata Mutual Fund',
        relative_path: '/mutual-funds/amc/tata-mutual-fund',
      },
      {
        title: 'Kotak Mutual Fund',
        relative_path: '/mutual-funds/amc/kotak-mutual-fund',
      },
      {
        title: 'HDFC Mutual Fund',
        relative_path: '/mutual-funds/amc/hdfc-mutual-fund',
      },
      {
        title: 'Aditya Birla Mutual Fund',
        relative_path: '/mutual-funds/amc/aditya-birla-mutual-fund',
      },
    ],
  },
  {
    title: '6-10',
    listItem: [
      {
        title: 'ICICI Prudential Mutual Fund',
        relative_path: '/mutual-funds/amc/icici-prudential-mutual-fund',
      },
      {
        title: 'UTI Mutual Fund',
        relative_path: '/mutual-funds/amc/uti-mutual-fund',
      },
      {
        title: 'DSP Mutual Fund',
        relative_path: '/mutual-funds/amc/dsp-mutual-fund',
      },
      {
        title: 'SBI Mutual Fund',
        relative_path: '/mutual-funds/amc/sbi-mutual-fund',
      },
      {
        title: 'Edelweiss Mutual Fund',
        relative_path: '/mutual-funds/amc/edelweiss-mutual-fund',
      },
    ],
  },
  {
    title: '11-15',
    listItem: [
      {
        title: 'Nippon India Mutual Fund',
        relative_path: '/mutual-funds/amc/nippon-india-mutual-fund',
      },
      {
        title: 'Sundaram Mutual Fund',
        relative_path: '/mutual-funds/amc/sundaram-mutual-fund',
      },
      {
        title: 'Mirae Asset Mutual Fund',
        relative_path: '/mutual-funds/amc/mirae-asset-mutual-fund',
      },
      {
        title: 'Axis Mutual Fund',
        relative_path: '/mutual-funds/amc/axis-mutual-fund',
      },
      {
        title: 'Parag Parikh Mutual Fund',
        relative_path: '/mutual-funds/amc/parag-parikh-mutual-fund',
      },
    ],
  },
  {
    title: '16-20',
    listItem: [
      {
        title: 'Canara Robeco Mutual Fund',
        relative_path: '/mutual-funds/amc/canara-robeco-mutual-fund',
      },
      {
        title: 'PGIM Mutual Fund',
        relative_path: '/mutual-funds/amc/pgim-mutual-fund',
      },
      {
        title: 'Navi Mutual Fund',
        relative_path: '/mutual-funds/amc/navi-mutual-fund',
      },
      {
        title: 'Invesco Mutual Fund',
        relative_path: '/mutual-funds/amc/invesco-mutual-fund',
      },
      {
        title: 'Motilal Oswal Mutual Fund',
        relative_path: '/mutual-funds/amc/motilal-oswal-mutual-fund',
      },
    ],
  },
]

export const MutualFundsCategoryColumns = [
  {
    title: 'Equity Funds',
    listItem: [
      {
        title: 'Best Large Cap Mutual Funds to Invest',
        relative_path: '/mutual-funds/equity/large-cap-funds',
      },
      {
        title: 'Top Mid Cap Mutual Funds in India',
        relative_path: '/mutual-funds/equity/mid-cap-funds',
      },
      {
        title: 'Best Small Cap Mutual Funds with High Returns',
        relative_path: '/mutual-funds/equity/small-cap-funds',
      },
      {
        title: 'Top Nifty 50 Index Funds',
        relative_path: '/mutual-funds/equity/nifty-50-index-funds',
      },
      {
        title: 'Best Nifty Next 50 Index Funds',
        relative_path: '/mutual-funds/equity/nifty-next-50-index-funds',
      },
      {
        title: 'Top Performing Global Index Funds',
        relative_path: '/mutual-funds/equity/global-index-funds',
      },
    ],
  },
  {
    title: 'Debt Funds',
    listItem: [
      {
        title: 'Best Liquid Mutual Funds for Parking Funds',
        relative_path: '/mutual-funds/debt/liquid-funds',
      },
      {
        title: 'Top Corporate Bond Funds in India',
        relative_path: '/mutual-funds/debt/corporate-bond-funds',
      },
      {
        title: 'Best Money Market Mutual Funds 2025',
        relative_path: '/mutual-funds/debt/money-market-funds',
      },
      {
        title: 'Top Bank and PSU Debt Mutual Funds',
        relative_path: '/mutual-funds/debt/banking-psu',
      },
      {
        title: 'Best Overnight Mutual Funds for Short-Term Investment',
        relative_path: '/mutual-funds/debt/overnight',
      },
    ],
  },
  {
    title: 'Hybrid Funds',
    listItem: [
      {
        title: 'Best Arbitrage Mutual Funds in India',
        relative_path: '/mutual-funds/hybrid/arbitrage-funds',
      },
      {
        title: 'Top Balanced Advantage Funds (BAFs)',
        relative_path: '/mutual-funds/hybrid/balanced-funds',
      },
      {
        title: 'Best Multi Asset Allocation Funds',
        relative_path: '/mutual-funds/hybrid/multi-asset-funds',
      },
      {
        title: 'Top Fund of Funds (FoF) for Diversification',
        relative_path: '/mutual-funds/hybrid/fund-of-funds',
      },
      {
        title: 'Best Retirement Mutual Funds for Long-Term Goals',
        relative_path: '/mutual-funds/hybrid/retirement',
      },
    ],
  },
  {
    title: 'Collections',
    listItem: [
      {
        title: 'Top Performing Mutual Funds',
        relative_path: '/mutual-funds/collection/investors-choice',
      },
      {
        title: 'Best SIP Plans in India 2025',
        relative_path: '/mutual-funds/collection/best-sip-funds',
      },
      {
        title: 'Best ELSS Tax Saving Funds',
        relative_path: '/mutual-funds/collection/elss-funds',
      },
      {
        title: 'Best Gold Mutual Funds',
        relative_path: '/mutual-funds/collection/precious-metals-funds',
      },
      {
        title: 'High Return Mutual Funds 2025',
        relative_path: '/mutual-funds/collection/high-return-mutual-funds',
      },
    ],
  },
]

export const ToolsAndCalculatorsColumns = [
  {
    title: '1-5',
    listItem: [
      {
        title: 'SIP Calculator – Monthly Investment Returns',
        relative_path: '/calculators/sip-calculator',
      },
      {
        title: 'Compound Interest Calculator – Investment Growth Over Time',
        relative_path: '/calculators/compound-interest-calculator',
      },
      {
        title: 'EMI Calculator – Loan Repayment Estimator',
        relative_path: '/calculators/emi-calculator',
      },
      {
        title: 'Home Loan EMI Calculator – Monthly Repayment Tool',
        relative_path: '/calculators/home-loan-emi-calculator',
      },
      {
        title: 'GST Calculator – Calculate GST Amount Online',
        relative_path: '/calculators/gst-calculator',
      },
    ],
  },
  {
    title: '6-10',
    listItem: [
      {
        title: 'Gratuity Calculator – Know Your Retirement Benefits',
        relative_path: '/calculators/gratuity-calculator',
      },
      {
        title: 'Lumpsum Calculator – One-Time Investment Returns',
        relative_path: '/calculators/lumpsum-calculator',
      },
      {
        title: 'Personal Loan EMI Calculator – Estimate Monthly Payments',
        relative_path: '/calculators/personal-loan-emi-calculator',
      },
      {
        title: 'Car Loan EMI Calculator – Vehicle Loan EMI Estimator',
        relative_path: '/calculators/car-loan-emi-calculator',
      },
      {
        title: 'Income Tax Calculator – Calculate Your Tax Liability',
        relative_path: '/calculators/income-tax-calculator',
      },
    ],
  },
  {
    title: '11-15',
    listItem: [
      {
        title: 'HRA Calculator – House Rent Allowance Tax Exemption',
        relative_path: '/calculators/hra-calculator',
      },
      {
        title: 'NPS Calculator – National Pension Scheme Returns',
        relative_path: '/calculators/nps-calculator',
      },
      {
        title: 'SSY Calculator – Sukanya Samriddhi Yojana Maturity Amount',
        relative_path: '/calculators/ssy-calculator',
      },
      {
        title: 'Discount Calculator – Percentage Off Savings Tool',
        relative_path: '/calculators/discount-calculator',
      },
      {
        title: 'Post Office RD Calculator – Recurring Deposit Returns',
        relative_path: '/calculators/post-office-rd-calculator',
      },
    ],
  },
  {
    title: '16-20',
    listItem: [
      {
        title: 'SWP Calculator – Systematic Withdrawal Plan Tool',
        relative_path: '/calculators/swp-calculator',
      },
      {
        title: 'PPF Calculator – Public Provident Fund Returns',
        relative_path: '/calculators/ppf-calculator',
      },
      {
        title: 'Interest Rate Calculator – Calculate Effective Rates',
        relative_path: '/calculators/interest-rate-calculator',
      },
      {
        title: 'CAGR Calculator – Compound Annual Growth Rate',
        relative_path: '/calculators/cagr-calculator',
      },
      {
        title: 'Simple Interest Calculator – Quick SI Calculation Tool',
        relative_path: '/calculators/simple-interest-calculator',
      },
    ],
  },
]

export const TopUSStocksColumns = [
  {
    title: '1-5',
    listItem: [
      {
        title: 'Apple Share Price – AAPL Stock Performance & Chart',
        relative_path: '/us-stocks/apple-inc-share-price-aapl',
      },
      {
        title: 'Berkshire Hathaway Share Price – BRK.A Stock Overview',
        relative_path:
          '/us-stocks/berkshire-hathaway-inc-class-a-share-price-brk.a',
      },
      {
        title: 'Tesla Share Price – TSLA Stock Today & Insights',
        relative_path: '/us-stocks/tesla-inc-share-price-tsla',
      },
      {
        title: 'Alphabet Share Price – GOOGL Stock Chart & Analysis',
        relative_path:
          '/us-stocks/alphabet-inc-class-a-shares-share-price-googl',
      },
      {
        title: 'Amazon Share Price – AMZN Stock Live & Forecast',
        relative_path: '/us-stocks/amazon-com-inc-share-price-amzn',
      },
    ],
  },
  {
    title: '6-10',
    listItem: [
      {
        title: 'Coca-Cola Share Price – KO Stock History & Dividend',
        relative_path: '/us-stocks/coca-cola-company-the-share-price-ko',
      },
      {
        title: 'Nvidia Share Price – NVDA Stock Growth & Trends',
        relative_path: '/us-stocks/nvidia-corporation-share-price-nvda',
      },
      {
        title: 'Microsoft Share Price – MSFT Stock Today & Chart',
        relative_path: '/us-stocks/microsoft-corporation-share-price-msft',
      },
      {
        title: 'Starbucks Share Price – SBUX Stock Analysis & Updates',
        relative_path: '/us-stocks/starbucks-corporation-share-price-sbux',
      },
      {
        title: 'PepsiCo Share Price – PEP Stock Dividends & Overview',
        relative_path: '/us-stocks/pepsico-inc-share-price-pep',
      },
    ],
  },
  {
    title: '11-15',
    listItem: [
      {
        title: 'Uber Share Price – UBER Stock Price Today',
        relative_path: '/us-stocks/uber-technologies-inc-share-price-uber',
      },
      {
        title: 'Oracle Share Price – ORCL Stock Chart & Performance',
        relative_path: '/us-stocks/oracle-corp-share-price-orcl',
      },
      {
        title: 'Walmart Share Price – WMT Stock Forecast & Growth',
        relative_path: '/us-stocks/walmart-inc-share-price-wmt',
      },
      {
        title: 'Netflix Share Price – NFLX Stock Trends & News',
        relative_path: '/us-stocks/netflix-inc-share-price-nflx',
      },
      {
        title: 'Freshworks Share Price – FRSH Stock Info & Chart',
        relative_path: '/us-stocks/freshworks-share-price-frsh',
      },
    ],
  },
  {
    title: '16-20',
    listItem: [
      {
        title: 'BlackRock Share Price – BLK Stock & Financials',
        relative_path: '/us-stocks/blackrock-inc-share-price-blk',
      },
      {
        title: 'Salesforce Share Price – CRM Stock Analysis',
        relative_path: '/us-stocks/salesforce-inc-share-price-crm',
      },
      {
        title: 'Citigroup Share Price – C Stock Overview & Chart',
        relative_path: '/us-stocks/citigroup-inc-share-price-c',
      },
      {
        title: 'Cognizant Share Price – CTSH Stock Performance',
        relative_path:
          '/us-stocks/cognizant-technology-solutions-corp-share-price-ctsh',
      },
      {
        title: 'Intel Share Price – INTC Stock Today & Forecast',
        relative_path: '/us-stocks/intel-corporation-share-price-intc',
      },
    ],
  },
]

export const USStocksCategoryColumns = [
  {
    title: 'Technology & Digital Innovation',
    listItem: [
      {
        title: 'Top E-commerce Stocks in the US',
        relative_path: '/us-stocks/e-commerce-stocks',
      },
      {
        title: 'Top Metaverse Stocks to Watch',
        relative_path: '/us-stocks/meta-stocks',
      },
      {
        title: 'Best AI Stocks in the US Market',
        relative_path: '/us-stocks/ai-stocks',
      },
      {
        title: 'FAANG Stocks – Facebook, Apple, Amazon, Netflix, Google',
        relative_path: '/us-stocks/faang',
      },
    ],
  },
  {
    title: 'Industry & Lifestyle',
    listItem: [
      {
        title: 'Top Travel & Leisure Stocks in the US',
        relative_path: '/us-stocks/travel-stocks',
      },
      {
        title: 'Best Healthcare Stocks Listed in the US',
        relative_path: '/us-stocks/pharma-stocks',
      },
      {
        title: 'Top Performing US Energy Stocks',
        relative_path: '/us-stocks/energy-stocks',
      },
      {
        title: 'Electric Vehicle (EV) Stocks in the US',
        relative_path: '/us-stocks/ev-stocks',
      },
    ],
  },
  {
    title: 'US Stocks Collections',
    listItem: [
      {
        title: 'Top US Tech Stocks to Invest In',
        relative_path: '/us-stocks/tech-stocks',
      },
      {
        title: 'Best US Consumer Brands Stocks',
        relative_path: '/us-stocks/brands',
      },
      {
        title: 'US Mid Cap Stocks',
        relative_path: '/us-stocks/mid-cap-stocks',
      },
      {
        title: 'US Stocks with Highest Returns',
        relative_path: '/us-stocks/highest-returns',
      },
      {
        title: "Warren Buffett's US Stock Picks",
        relative_path: '/us-stocks/warren-buffet',
      },
    ],
  },
  {
    title: 'US Stocks Categories',
    listItem: [
      {
        title: 'Top Gainers in US Stock Market Today',
        relative_path: '/us-stocks/top-gainers',
      },
      {
        title: 'Top Losers in US Stock Market Today',
        relative_path: '/us-stocks/top-losers',
      },
      {
        title: 'Top US Pharma & Biotech Stocks',
        relative_path: '/us-stocks/pharma-stocks',
      },
      {
        title: 'US Stock ETFs',
        relative_path: '/us-stocks/etf',
      },
      {
        title: 'Advanced US Stock Screener Tool',
        relative_path: '/us-stocks/screener',
      },
    ],
  },
]

// Main footer links config

export const FooterV2Links: TFooterV2Links[] = [
  {
    title: '',
    rowsData: [
      {
        title: 'Top Indian Stocks',
        columnsData: TopIndianStocksColumns,
      },
      {
        title: 'Indian Stocks Category',
        columnsData: IndianStocksCategoryColumns,
      },
      {
        title: 'Top Indices',
        columnsData: TopIndicesColumns,
      },
      {
        title: 'Top US Stocks',
        columnsData: TopUSStocksColumns,
      },
    ],
  },
  {
    title: '',
    rowsData: [
      {
        title: 'US Stocks Category',
        columnsData: USStocksCategoryColumns,
      },
      {
        title: 'Top Mutual Funds',
        columnsData: TopMutualFundsColumns,
      },
      {
        title: 'Top Mutual Fund AMCs',
        columnsData: TopMutualFundAMCsColumns,
      },
      {
        title: 'Mutual Fund Category',
        columnsData: MutualFundsCategoryColumns,
      },
    ],
  },
  {
    title: '',
    rowsData: [
      {
        title: 'Tools and Calculators',
        columnsData: ToolsAndCalculatorsColumns,
      },

      {
        title: 'More',
        columnsData: MoreColumns,
      },
    ],
  },
]
